import React from 'react';
import PropTypes from 'prop-types';
import './CustomControl.css';
import withRender from '../../../hoc/withRender';
import homeIcon from '../../../assets/baseline-home-24px.svg';
import exploreIcon from '../../../assets/baseline-explore-24px.svg';
var CustomControl = function CustomControl(props) {
  var map = props.map,
    initialOptions = props.initialOptions;
  var classNames = ['CustomControl', props.type];
  var handleClick = function handleClick() {
    var mapInfo = {
      lng: map.getCenter()[0],
      lat: map.getCenter()[1],
      zoom: map.getZoom(),
      pitch: map.getPitch(),
      bearing: map.getBearing()
    };
    switch (props.type) {
      case 'compass':
        {
          mapInfo.bearing = 0;
          break;
        }
      case 'home':
        {
          mapInfo.center = [initialOptions.lng, initialOptions.lat];
          mapInfo.zoom = initialOptions === null || initialOptions === void 0 ? void 0 : initialOptions.zoom;
          mapInfo.pitch = initialOptions.pitch || 0;
          mapInfo.bearing = initialOptions.bearing || 0;
          break;
        }
    }
    map.flyTo(mapInfo);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames.join(' '),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-overlay"
  }, /*#__PURE__*/React.createElement("img", {
    src: props.type === 'compass' ? exploreIcon : homeIcon
  })));
};
CustomControl.propTypes = process.env.NODE_ENV !== "production" ? {
  map: PropTypes.object.isRequired,
  initialOptions: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['compass', 'home']).isRequired
} : {};
export default CustomControl;